import React from 'react';
import { techStackDetails } from '../Details';

function Technologies() {
  const {
    kotlin,
    firebase,
    google_cloud_console,
    google_play_console,
    flutter,
    laravel,
    php,
    kmm,
    jetpack,
    postgre,

    android_studio,
    notion,
    trello,
    git,
    github,
    figma,
    vscode,
    postman,
    navicat,
    intellij,
    phpstorm,
    phpmyadmin,
    xampp,
  } = techStackDetails;
  return (
    <main className='container mx-auto max-width pt-10 pb-20 '>
      <section>
        <h1 className='text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold'>
          Tech Stack
        </h1>
        <p className='text-content py-2 lg:max-w-3xl'>
          Technologies I've been working with recently
        </p>
      </section>
      <section className='grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6'>
        <img src={kotlin} title='kotlin' alt='' />
        <img src={firebase} title='firebase' alt='' />
        <img src={google_cloud_console} title='google_cloud_console' alt='' />
        <img src={google_play_console} title='google_play_console' alt='' />
        <img src={flutter} title='flutter' alt='' />
        <img src={laravel} title='laravel' alt='' />
        <img src={php} title='php' alt='' />
        <img src={kmm} title='kmm' alt='' />
        <img src={jetpack} title='jetpack' alt='' />
        <img src={postgre} title='postgre' alt='' />
      </section>
      <section>
        <h1 className='text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold'>
          Tools
        </h1>
      </section>
      <section className='grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6'>
        <img src={android_studio} title='Android Studio' alt='' />
        <img src={notion} title='Notion' alt='' />
        <img src={trello} title='Trello' alt='' />
        <img src={git} title='Git' alt='Git' />
        <img src={github} title='Github' alt='Github' />
        <img src={figma} title='Figma' alt='' />
        <img src={vscode} title='Visual Studio Code' alt='' />
        <img src={postman} title='Postman' alt='' />
        <img src={navicat} title='navicat' alt='' />
        <img src={intellij} title='intellij' alt='' />
        <img src={phpstorm} title='phpstorm' alt='' />
        <img src={phpmyadmin} title='phpmyadmin' alt='' />
        <img src={xampp} title='xampp' alt='' />
      </section>
    </main>
  );
}

export default Technologies;
